import './CalendarStatisticChartCard.scss'
import { Knob } from 'primereact/knob'

export default function CalendarStatisticChartCard(props: any) {
  let { labelText, knobValue, valueColor } = props

  if (knobValue === null || knobValue === undefined) knobValue = 0

  if (valueColor === null || valueColor === undefined) valueColor = 'rgb(61, 132, 153)'

  return (
    <div className="card-knob">
      <label>{labelText}</label>
      <Knob value={knobValue} readOnly strokeWidth={7} valueColor={valueColor} valueTemplate={'%{value}'} />
    </div>
  )
}
